export const Data = [
  {
    icon: "/images/icons/dashboardIcon.svg",
    iconActive: "/images/icons/dashboardIconActive.svg",
    text: "Dashboard",
    link: "/dashboard/main",
  },
  {
    icon: "/images/icons/customerIcon.svg",
    iconActive: "/images/icons/customerIconActive.svg",
    text: "Customer",
    link: "/dashboard/customer",
  },
  {
    icon: "/images/icons/serviceProviderIcon.svg",
    iconActive: "/images/icons/serviceProviderIconActive.svg",
    text: "Service Providers",
    link: "/dashboard/serviceproviders",
  },
  {
    icon: "/images/icons/jobsManagementIcon.svg",
    iconActive: "/images/icons/jobsManagementIconActive.svg",
    text: "Jobs Management",
    link: "/dashboard/jobsmanagement",
  },
  {
    icon: "/images/icons/serviceManagementIcon.svg",
    iconActive: "/images/icons/serviceManagementIconActive.svg",
    text: "Services Management",
    link: "/dashboard/servicesmanagement/main",
    subItems: [
      { text: "Services Management", link: "/dashboard/servicesmanagement/main" },
      { text: "Services Management on Homescreen", link: "/dashboard/servicesmanagement/homescreen" },
    ],
  },
  {
    icon: "/images/icons/privacyPolicyIcon.svg",
    iconActive: "/images/icons/privacyPolicyIconActive.svg",
    text: "Privacy Policy",
    link: "/dashboard/privacypolicy",
  },
  {
    icon: "/images/icons/termsIcon.svg",
    iconActive: "/images/icons/termsIconActive.svg",
    text: "Terms & Conditions",
    link: "/dashboard/terms",
  },
];
